import { type UseNodeAssetsChannelOptions, useNodeAssetsChannel } from '@/hooks/websocket/useNodeAssetsChannel';

export const useAlbumChannel = (albumId: string | undefined, options: UseNodeAssetsChannelOptions = {}): void => {
  useNodeAssetsChannel(albumId ? `album.${albumId}` : undefined, options);
};
